/** @format */

import { Link } from "react-router-dom";
import Header from "../../components/partials/dashboard/HeaderStyle/pub-header";
import backgroundImage from "src/assets/images/landing/fl-bg.jpeg";

const UsrIndex = () => {
  return (
    <div
      id="content-page"
      className="min-vh-100 d-flex flex-column"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container-fluid d-flex flex-grow-1 justify-content-center align-items-center bg-black bg-opacity-25">
        <div className="row w-100">
          <div className="col-md-4 offset-md-1 d-flex flex-column justify-content-left align-items-left text-left">
            <h1 className="display-4 fw-bold text-black">User Page</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsrIndex;
